import axios from 'axios'
import { config } from '../shared/app.config'

export default {
  getList(page, per_page, search, timestamp, user, client, department_id = null, attendance_status = null, orderBy = null) {
    return axios.post(`${config.webApiBase}/users/list/partes`, {
      page,
      per_page,
      search,
      timestamp,
      user_id: user,
      client_id: client,
      department_id,
      attendance_status,
      orderBy
    })
  },
  generateMonthly(timestamp, clientId) {
    return axios.get(`${config.webApiBase}/users/pdf/monthly/${timestamp}/${clientId}`)
  },
  edit(user) {
    return axios.post(`${config.webApiBase}/journeyday/update`, user)
  },
}
